export default __webpack_public_path__ + "static/media/Code.8f532c47.png";